import React, { useState, useEffect } from "react";
import MenuAdmin from "./navAdmin/Menu";
import Footer from "../footer/Footer";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import { FaHome } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import Sidebar from "./sidebar/sidebar";
import HeadBar from "../public/headBar/HeadBar";
import MenuLegged from "../header/Menu";

function AdminSetting() {
  const { section, subsection, action, id } = useParams();
  const location = useLocation();
  const { title } = location.state || {};
  const [isWideWindow, setIsWideWindow] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsWideWindow(false);
      } else {
        setIsWideWindow(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isWideWindow]);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "สำหรับแอดมิน", url: "" },
    ...(section === "usermanagement"
      ? [
          { name: "จัดการผู้ใช้งาน", url: "/admin/usermanagement" },
          ...(subsection === "add-usermanagement"
            ? [
                {
                  name: "เพิ่มผู้ใช้งาน",
                  url: "/admin/usermanagement/add-usermanagement",
                },
              ]
            : subsection === "edit-usermanagement"
            ? [
                {
                  name: "แก้ไขผู้ใช้งาน",
                  url: "/admin/usermanagement/edit-usermanagement",
                },
              ]
            : subsection === "view-usermanagement"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/usermanagement/view-usermanagement/${
                    id ? id : action
                  }`,
                },
              ]
            : []),
        ]
      : section === "management"
      ? [
          { name: "จัดการเนื้อหา", url: "/admin/management" },
          {
            name:
              subsection === "menu"
                ? "เมนู"
                : subsection === "document"
                ? "เอกสารที่เกี่ยวข้อง"
                : subsection === "laboratory-inspection-guideline"
                ? "เเนวทางการตรวจ"
                : subsection === "press-release"
                ? "ข่าวประกาศ"
                : subsection === "faq"
                ? "คำถามที่พบบ่อย"
                : subsection === "contact"
                ? "ข้อมูลที่ติดต่อ"
                : subsection === "comment"
                ? "ความคิดเห็น"
                : subsection === "questionnaire"
                ? "สำรวจความพึงพอใจ"
                : subsection === "banner"
                ? "แบนเนอร์" 
                : subsection === "pharmacogenetics"
                ? "แบบฟอร์มส่งตรวจ" 
                : "ไม่พบเนื้อหา",
            url: subsection
              ? `/admin/management/${subsection}`
              : "/admin/management",
          },
          ...(action === "add-laboratory"
            ? [
                {
                  name: "เพิ่มเเนวทางการตรวจ",
                  url: "/admin/management/laboratory-inspection-guideline/add-laboratory",
                },
              ]
            : action === "edit-laboratory"
            ? [
                {
                  name: "แก้ไขเเนวทางการตรวจ",
                  url: "/admin/management/laboratory-inspection-guideline/edit-laboratory",
                },
              ]
            : action === "view-laboratory"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/management/laboratory-inspection-guideline/view-laboratory/${id}`,
                },
              ]
            : action === "add-contact"
            ? [
                {
                  name: "เพิ่มข้อมูลการติดต่อ",
                  url: "/admin/management/contact/add-contact",
                },
              ]
            : action === "edit-contact"
            ? [
                {
                  name: "แก้ไขข้อมูลการติดต่อ",
                  url: "/admin/management/contact/edit-contact",
                },
              ]
            : action === "view-contact"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/management/contact/view-contact/${id}`,
                },
              ]
            : action === "add-faq"
            ? [
                {
                  name: "เพิ่มคำถาม",
                  url: "/admin/management/faq/add-faq",
                },
              ]
            : action === "edit-faq"
            ? [
                {
                  name: "แก้ไขคำถาม",
                  url: "/admin/management/faq/edit-faq",
                },
              ]
            : action === "view-faq"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/management/faq/view-faq/${id}`,
                },
              ]
            : action === "view-document"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/management/faq/view-faq/${id}`,
                },
              ]
            : action === "add-pressrelease"
            ? [
                {
                  name: "เพิ่มข่าวประกาศ",
                  url: "/admin/management/press-release/add-pressrelease",
                },
              ]
            : action === "edit-pressrelease"
            ? [
                {
                  name: "แก้ไขข่าวประกาศ",
                  url: "/admin/management/press-release/edit-pressrelease",
                },
              ]
            : action === "view-pressrelease"
            ? [
                {
                  name: `${title}`,
                  url: `/admin/management/press-release/view-pressrelease/${id}`,
                },
              ]
            : []),
        ]
      : section === "labinformation"
      ? [
          { name: "กรองข้อมูลแล็บ", url: "/admin/labinformation" },
          {
            name:
              subsection === "patient"
                ? "รายชื่อผู้ป่วยแจ้งตรวจสอบข้อมูล"
                : subsection === "patients"
                ? "รายชื่อผู้ที่มีการตรวจซ้ำ"
                : "ไม่พบเนื้อหา",
            url: subsection
              ? `/admin/labinformation/${subsection}`
              : "/admin/labinformation",
          },
        ]
      : section === "hospitalsetting"
      ? [
          { name: "ตั้งค่าโรงพยาบาล", url: "/admin/hospitalsetting" },
          ...(subsection === "add-hospital"
            ? [
                {
                  name: "เพิ่มโรงพยาบาล",
                  url: "/admin/hospitalsetting/add-hospital",
                },
              ]
            : []),
        ]
      : section === "historyLog" 
      ? [
        { name: "ประวัติเข้าใช้งาน" },
       
      ]
      : [{ name: "ไม่พบเมนู", url: "/" }]),
  ];

  return (
    <>
      {/* <MenuLegged menuActive={"adminsetting"} /> */}
      {isWideWindow ? (
        <div className="lg:pt-[30px] pt-[110px] mt-[10px]">
          <Breadcrumb pathItems={pathItems} />
        </div>
      ) : (
        <div className="pt-[40px]"></div>
      )}
      <div className="layout-page">
        <div style={{ display: "flex" }}>
          <Sidebar
            role={"admin"}
            page={section}
            subsection={subsection}
            action={action}
            id={id}
          />
        </div>
      </div>
    </>
  );
}

export default AdminSetting;
